<template>
  <div class="blog">
    <div
      class="section"
      :style="{
        backgroundImage:
          `url(` +
          require(`@/assets/screenshots/${simprojets[currentIndex].screenshots![0]}`) +
          `)`,
      }"
    />
    <!-- <div class="checkout">Sprawdź moje wpisy</div> -->
    <div class="abc">
      <header>{{ $t('home.simulationsHeader') }}</header>
      <div class="sim-slider-container">
        <div
          class="articles"
          :style="{
            left: `-${currentIndex * 1260}px`,
            '--idx': currentIndex,
          }"
        >
          <Simulation v-for="sim in simprojets" :key="sim.title" :sim="sim" />
        </div>
      </div>
      <div class="barcont">
        <div class="button left" @click="left()">
          <ic icon="angles-left" />
        </div>
        <div class="bar">
          <ic
            class="dot"
            icon="circle"
            :class="{ active: i === currentIndex + 1 }"
            v-for="i in simprojets.length"
            :key="i"
          />
        </div>
        <div class="button right" @click="right()">
          <ic icon="angles-right" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Simulation from './Simulation.vue'

// 1. Importujemy dane ze wszystkich języków
import projectsPl from '@/data/pl/projects'
import projectsEn from '@/data/en/projects'
import projectsDe from '@/data/de/projects'
import projectsEs from '@/data/es/projects'
import projectsRu from '@/data/ru/projects'
import projectsJp from '@/data/jp/projects'

// Zdefiniowane interfejsy dla TypeScriptu (jeśli masz je w pliku interfaces.ts, możesz je zaimportować)
interface Project {
  title: string
  description: string
  longdescription?: string
  github: string
  icon: string
  langs: string[]
  main?: boolean
  simulation?: boolean
  screenshots?: string[]
  tags?: string[]
}

interface ProjectGroup {
  title: string
  icon: string
  description: string
  projects: Project[]
}

// 2. Mapa języków
const projectsMap: Record<string, ProjectGroup[]> = {
  pl: projectsPl,
  en: projectsEn,
  de: projectsDe,
  es: projectsEs,
  ru: projectsRu,
  jp: projectsJp,
}

export default defineComponent({
  components: {
    Simulation,
  },
  // 3. W data zostawiamy tylko to, co zmienia się lokalnie w komponencie
  data() {
    return {
      currentIndex: 0,
      slideMoveTime: 0,
    }
  },
  computed: {
    // 4. simprojets przeniesione do computed – reaguje na zmianę języka!
    simprojets(): Project[] {
      const locale = (this as any).$i18n.locale as string
      const currentProjects = projectsMap[locale] || projectsMap['en']

      // Wykonujemy Twoją logikę filtrowania na załadowanym języku
      return currentProjects
        .map((c) => c.projects)
        .reverse()
        .flat()
        .filter((p) => p.simulation)
    },
  },
  methods: {
    left() {
      this.currentIndex =
        (this.currentIndex - 1 + this.simprojets.length) %
        this.simprojets.length
      this.slideMoveTime = -5
    },
    right() {
      this.currentIndex = (this.currentIndex + 1) % this.simprojets.length
      this.slideMoveTime = -5
    },
    autoSlide() {
      setInterval(() => {
        this.slideMoveTime++
        if (this.slideMoveTime >= 7) {
          this.currentIndex = (this.currentIndex + 1) % this.simprojets.length
          this.slideMoveTime = 0
        }
      }, 1000)
    },
  },
  mounted() {
    this.autoSlide()
  },
})
</script>

<style lang="scss" scoped>
.blog {
  display: flex;
  justify-content: center;
  padding: 40px 0;
  margin: 40px 0;
  width: 100%;
  position: relative;

  @media (max-width: 1240px) {
    padding: 20px 0;
    margin: 20px 0;
  }
}

.sim-slider-container {
  width: 1220px;
  overflow: hidden;
  position: relative;

  @media (max-width: 1240px) {
    width: 100%;
    max-width: 100%;
  }
}

.articles {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 40px;
  position: relative;
  transition: left 0.5s ease;

  @media (max-width: 1240px) {
    gap: 0;
    left: calc(var(--idx) * -100%) !important;
  }
}

.section {
  width: 100vw;
  height: 100%;
  position: absolute;
  top: 0;
  left: calc(-50vw + 50%);
  background: $dark;
  background-size: cover;
  background-position: center;
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #28353abb;
    backdrop-filter: blur(10px);
  }
}

.abc {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media (max-width: 1240px) {
    padding: 20px 15px;
    box-sizing: border-box;
  }

  .dot {
    font-size: 10px;
    animation: float 3s ease-in-out infinite;
    &.active {
      color: $dark;
    }
  }
}

.barcont {
  display: flex;
  align-items: center;
  font-size: 20px;
  gap: 20px;
  color: $light;
  margin-top: 20px;
}

.bar {
  background: $dark_gray;
  display: inline-flex;
  gap: 5px;
  padding: 10px 30px;
  border-radius: 1000px;
}

.button {
  cursor: pointer;
}

header {
  font-size: 24px;
  font-weight: 600;
  color: $light;
  margin-bottom: 20px;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 12px;
    text-align: center;
  }
}
</style>
